import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Eye, Pencil, Trash2 } from "lucide-react";
import { TableCell, TableRow } from "@/components/ui/table";

interface ArticleTableRowProps {
  id: string;
  title: string;
  category?: string;
  slug?: string;
  createdAt: string;
  isSpecial?: boolean;
  onDelete: (id: string, isSpecial?: boolean) => void;
  deletingId: string | null;
}

export const ArticleTableRow = ({
  id,
  title,
  category,
  slug,
  createdAt,
  isSpecial = false,
  onDelete,
  deletingId,
}: ArticleTableRowProps) => {
  return (
    <TableRow>
      <TableCell className="font-medium">{title}</TableCell>
      <TableCell>{isSpecial ? slug : category}</TableCell>
      <TableCell>
        {new Date(createdAt).toLocaleDateString("ja-JP")}
      </TableCell>
      <TableCell className="text-right space-x-2">
        <Button
          variant="outline"
          size="sm"
          asChild
          className="text-magazine-accent hover:text-magazine-accent/80"
        >
          <Link to={isSpecial ? `/articles/special/${slug}` : `/articles/${id}`}>
            <Eye className="h-4 w-4" />
          </Link>
        </Button>
        <Button
          variant="outline"
          size="sm"
          asChild
          className="text-magazine-primary hover:text-magazine-primary/80"
        >
          <Link to={isSpecial ? `/edit-special-article/${id}` : `/edit-article/${id}`}>
            <Pencil className="h-4 w-4" />
          </Link>
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="text-magazine-secondary hover:text-magazine-secondary/80"
          onClick={() => onDelete(id, isSpecial)}
          disabled={deletingId === id}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </TableCell>
    </TableRow>
  );
};